import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import { JOIN_ORDER_AND_MISSION } from "../../../../common/queries";
import useOrderMissionDetailsColumns from "../../../../hooks/useOrderMissionDetailsColumns";
import EntityJoinTable from "../../../common/tables/EntityJoinTable";

export default function AllOrdersSection() {
  const { t } = useTranslation();
  const { tabId } = useParams();
  const navigate = useNavigate();

  const columns = useOrderMissionDetailsColumns();

  const onRowClick = useCallback((params, ev) => {
    navigate(!tabId ? `./all/${params.row.missionId}/${params.id}` : `./${params.row.missionId}/${params.id}`, { relative: "path" });
  }, [navigate, tabId]);

  return (
    <EntityJoinTable
      sortDescendingByDefault
      tableId="all_orders"
      type="Order"
      join={JOIN_ORDER_AND_MISSION}
      onRowClick={onRowClick}
      columns={columns}
      emptyStateTitle={t("allOrders:emptyStateTitle")}
      emptyStateDescription={t("allOrders:emptyStateDescription")}
      serverSidePaging
      xs={12}
    />
  );
}